import { createFileRoute, redirect } from "@tanstack/react-router";

import { ACTIVATION_TOKEN_COOKIE_KEY } from "@/config/constants";
import {
  TOKEN_HANDOFF_MAX_AGE_SECONDS,
  writeTokenCookie,
} from "@/routing/tokenHandoff";

/** `permanent: false` in `getServerSideProps` is a 307. */
const TEMPORARY_REDIRECT = 307;

export const Route = createFileRoute(
  "/_app/activation/$activationtoken/confirm"
)({
  beforeLoad: ({ params }) => {
    const token = params.activationtoken;
    if (!token) {
      return;
    }

    writeTokenCookie({
      name: ACTIVATION_TOKEN_COOKIE_KEY,
      value: token,
      options: {
        maxAge: TOKEN_HANDOFF_MAX_AGE_SECONDS,
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
        path: "/",
        secure: true,
        sameSite: "lax",
      },
    });

    throw redirect({
      to: "/activation/confirm",
      statusCode: TEMPORARY_REDIRECT,
    });
  },
});
